module.exports = __webpack_public_path__ + "img/food_pack.f2bc8a1d.png";